import React, { useEffect, useState } from 'react';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import Form from '../../components/Form/Form';
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from '../../services/data.service';
import Unauthorized from './../Authentication/Unauthorized';
import Genders_popup_CreateGender from './Popups/Genders_popup_CreateGender';

const GendersView: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const { handleException, handleResult } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData()
    }, [])

    function getTableData() {
        setShowSpinner(true);
        DataService
            .get<any[]>(`api/v1/Genders/`)
            .then(response => {
                setShowSpinner(false);
                setData(response);
            })
            .catch(e => {
                setShowSpinner(false);
                handleException(e)
            });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/Genders/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { title: 'Id', key: true, dataProp: 'id', dataType: 'number', visible: false },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Begin date', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End date', dataProp: 'endDate', dataType: 'date' },
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditGender)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    if (!isAuthorizedFor(ApplicationFunctions.ViewGender)) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form>
                <Form.Header title="Genders" >
                    <ActionMenu title="Actions">
                        <ActionMenuItem width={300} icon="fa fa-plus" iconVariant="success" title={"Create new Gender"} onClick={() => { setShowPopup(true); }} appFunction={ApplicationFunctions.EditGender} />
                    </ActionMenu>
                </Form.Header>
                <Form.Content>
                    <DataTable
                        name='dtGenders'
                        colInfos={colInfos}
                        tableData={data}
                        navigateTitle='Gender'
                        navigateUrl='/plm/UserManagement/Gender/'
                    />
                </Form.Content>
            </Form>
            {showPopup && (<Genders_popup_CreateGender show={showPopup} onHide={() => { setShowPopup(false); getTableData() }} />)}
            {showSpinner && (<SpinnerOverlay />)}
        </div>
    );
}
export default GendersView;
